import { gql } from '@moonpig/web-core-graphql'

export const GetMultiBuyListCountGQL = gql`
  query GetMultiBuyListCount {
    me {
      multiBuyList {
        id
        items {
          ... on MultiBuyListPersonalisableItem {
            id
            variant {
              productId
            }
          }
        }
      }
    }
  }
`
